import "./App.css";
import { SnackbarProvider } from 'notistack'; // or your NotificationProvider
import { NotificationProvider } from "./utils/NotificationContext.js";
import Login from "./Login/Login/Login.jsx";
import Signup from "./Login/SignUp/SignUp.jsx";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ManningAggrement from "./Vessel_Owner/ManningAggrement/ManningAggrement.jsx";
import HomePage from "./Homepage/HomePage.jsx";
import ManningAggrementDisplay from "./Vessel_Owner/ManningAggrementDisplay/ManningAggrementDisplay.jsx";
import VesselOwnerTable from "./Vessel_Owner/VesselOwnerTable/VesselOwnerTable.jsx";
import VesselOwnerForm from "./Vessel_Owner/VesselOwnerForm/VesselOwnerForm.jsx";
import VesselForm from "./Vessel_Owner/VesselForm/VesselForm.jsx";
import VesselTable from "./Vessel_Owner/VesselTable/VesselTable.jsx";
import VesselMangerForm from "./Vessel_Manager/VesselMangerForm/VesselMangerForm.jsx";
import CrewingAgentTable from "./Crewing_Agent/Crewing_agent_table/CrewingAgentTable.jsx";
import CrewingAgentForm from "./Crewing_Agent/Crewing_agentForm/CrewingAgentForm.jsx";
import VesselManagerTable from "./Vessel_Manager/VesselMangerTable/VesselMangerTable.jsx";
import AssignedVesselTable from "./Vessel_Owner/AssignedVesselTable/AssignedVesselTable.jsx";
import CrewProfile from "./crew/CrewProfile/CrewProfile.jsx";
import CrewProfileTable from "./crew/CrewProfileTable/CrewProfileTable.jsx";
import AssignedCrew from "./crew/AssignedCrew/AssignedCrew.jsx"
import AgentDetails from "./AgentDetails.jsx";
import ContractForm from "./Contract/ContractForm/ContractForm.jsx";
import ContractTable from "./Contract/ContractTable/ContractTable.jsx";
import EditContractTable from "./Contract/EditContractTable/EditContractTable.jsx";
import CompanyVessel from "./CompanyVessel/CompanyVessel.jsx";
import ExecutiveForm from "./CompanyVessel/ExecutiveForm/ExecutiveForm.jsx";
import ExecutiveTable from "./CompanyVessel/ExecutiveTable/ExecutiveTable.jsx";
import './style/tailwind.css'
import Otp from "./Login/OTP/otp.jsx";
import ForgotPassword from "./Login/ForgotPassword/ForgotPassword.jsx";
import CrewInfo from "./crew/CrewInfo/CrewInfo.jsx";
import VesselOwnerInfo from "./Vessel_Owner/VesselOwnerInfo/VesselOwnerInfo.jsx";
import ExecutiveVesselInfo from "./CompanyVessel/ExecutiveVesselInfo/ExecutiveVesselInfo.jsx";
import VesselTableByVesselOwnerId from "./Vessel_Owner/VesselTable/VesselTableByVesselOwnerId.jsx";
import Vesselsforagent from "./Vessel_Owner/Vesselsforagent/Vesselsforagent.jsx";
import AddRank from "./crew/Rank/AddRank/AddRank.jsx";
import RankTable from "./crew/Rank/Rank/RankTable.jsx";
import { Add } from "@mui/icons-material";
import CreateRank from "./crew/Rank/CreateRank/CreateRank.jsx";
import ContractUpdate from "./Contract/UpdateContarct/ContractUpdate.jsx";
import { ThemeProvider, createTheme } from "@mui/material";
import AdminSignup from "./Login/AdminSignup/AdminSignup.jsx";
// import ContractDocument from "./Contract/ContractDocument/ContractDocument.jsx";
import CrewingAgentContractDocument from "./Contract/ContractDocument/CrewingAgentContractDocument.jsx";
import VesselOwnerContract from "./Vessel_Owner/VesselOwnerContract/VesselOwnerContract.jsx";
import SignInSignOff from "./Contract/SignInSignOff/SignInSignOff.jsx";
import ExpiringShipDetails from "./Vessel_Owner/VesselTable/getExpiryDatedvessels.jsx";
import UserList from "./adminAcess/UserList.jsx";
import AdminDashboard from "./AdminDashboard/AdminDashboard.jsx";

import AllAdminCrewing from "./AdminDashboard/AllAdminCrewing.jsx";
import AllAdminContract from "./AdminDashboard/AllAdminContract/AllAdminContract.jsx"
import AdminContractDetails from "./AdminDashboard/AllAdminContract/AdminContractDetails.jsx";
import CrewAgentDetails from "./AdminDashboard/crewingagentDetails.jsx";
import CharteredVessel from "./Vessel_Owner/CharteredVessel/CharteredVessel.jsx";
import VesselOwnerContracts from "./Vessel_Owner/VesselOwnerContracts/VesselOwnerContracts.jsx";
import VesselOwnerLayouts from "./Layouts/VesselOwnerLayouts.jsx";
import VesselOwnerProfile from "./Vessel_Owner/VesselOwner/VesselOwnerProfile.jsx";
import DashBoard from "./Vessel_Owner/VesselOwner/DashBoard.jsx";
import AddVessel from "./Vessel_Owner/VesselOwner/AddVessel.jsx";
import VesselList from "./Vessel_Owner/VesselOwner/VesselList.jsx";
import AssignedVessel from "./Vessel_Owner/VesselOwner/AssignedVessel.jsx";
import AddCrew from "./Vessel_Owner/VesselOwner/AddCrew.jsx";
import CrewList from "./Vessel_Owner/VesselOwner/CrewList.jsx";
import BsmContracts from "./Vessel_Owner/VesselOwner/BsmContracts.jsx";
import VesselContarcts from "./Vessel_Owner/VesselOwner/VesselContarcts.jsx";
import SetPermissionPage from "./permissionPage/permission.jsx"
import SignInSignOffCrewing from "./Crewing_Agent/SignInSignOffCrewing/SignInSignOffCrewing.jsx";
import AddExecutive from "./Vessel_Owner/VesselOwner/AddExecutive.jsx";
import ExecutiveList from "./Vessel_Owner/VesselOwner/ExecutiveList.jsx";
import ContractForVesselOwner from "./Contract/ContractTable/VesselOwnersContract.jsx";
import CrewingAgentFormIList from "./Crewing_Agent/CrewingAgentFormI/CrewingAgentFormIList.jsx";
import StripeSubscriptionForm from "./Vessel_Owner/StripeSubscriptionForm/VesselOwnerSubscriptionForm.jsx";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import SubscriptionForm from "./Vessel_Owner/StripeSubscriptionForm/VesselOwnerSubscriptionForm.jsx";
import VesselOwnerSubscriptionHistory from "./Vessel_Owner/StripeSubscriptionForm/VesselOwnerSubscriptionHistory.jsx";
import StripSubscription from "./Vessel_Owner/StripeSubscriptionForm/StripSubscription.jsx";
import SubscriptionWrapper from "./Vessel_Owner/StripeSubscriptionForm/SubscriptionWrapper.jsx";
import Wallet from "./Vessel_Owner/VesselOwner/Wallet.jsx";
import ModifySubscription from "./Vessel_Owner/StripeSubscriptionForm/ModifySubscription.jsx";
import RenewSubscription from "./Vessel_Owner/StripeSubscriptionForm/RenewSubscription.jsx";
import TopupSuccessPage from "./Vessel_Owner/VesselOwner/TopupSuccessPage.jsx";
import VesselOwnerRefundRequests from "./AdminDashboard/VesselOwnerRefundRequests.jsx";
import CrewingAgentDrawer from "./Crewing_Agent/ControlPannel/CrewingAgentDrawer.jsx";
import CrewingAgentLayout from "./Crewing_Agent/ControlPannel/CrewingAgentLayout.jsx";
import CrewingAgentDashboard from "./Crewing_Agent/DrawerTabs/CrewingAgentDashboard.jsx";
import CrewingAgentProfile from "./Crewing_Agent/DrawerTabs/CrewingAgentProfile.jsx";
import CrewingContracts from "./Crewing_Agent/DrawerTabs/CrewingContracts.jsx";
import CrewingEditContractTable from "./Crewing_Agent/DrawerTabs/CrewingEditContractTable.jsx";

import CrewingAgentBankDetails from "./Crewing_Agent/DrawerTabs/CrewingAgentBankDetails.jsx";
import UploadCV from "./Crewing_Agent/DrawerTabs/UploadCrewCV.jsx";
import UploadedCVsList from "./Crewing_Agent/DrawerTabs/UploadedCVsList.jsx";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AssignedVessels from "./Crewing_Agent/DrawerTabs/AssignedVessels.jsx";
import AssignedCrewToAgent from "./Crewing_Agent/DrawerTabs/AssignedCrewToAgent.jsx";
import Signinsignoffcrewingagent from "./Crewing_Agent/DrawerTabs/Signinsignoffcrewingagent.jsx";
import Seaservicecrewing from "./Crewing_Agent/DrawerTabs/Seaservicecrewing.jsx";
import LogOut from "./Crewing_Agent/DrawerTabs/LogOut.jsx";
import Crewcvs from "./crew/CrewCV/Crewcvs.jsx";
import Listofcvs from "./Vessel_Owner/VesselOwner/Listofcvs.jsx";
import AddVacancy from "./Vessel_Owner/VesselOwner/AddVacancy.jsx";
import VacancyList from "./Vessel_Owner/VesselOwner/VacancyList.jsx";
import Listofvacancy from "./crew/Vacancy/Listofvacancy.jsx";
import CrewingAgentExecutive from "./Crewing_Agent/DrawerTabs/CrewingAgentExecutive.jsx";
import ListOfCrewingAgentExecutive from "./Crewing_Agent/DrawerTabs/ListOfCrewingAgentExecutive.jsx";
import VacancyCvMatcher from "./Vessel_Owner/VesselOwner/vacancycvs.jsx";
import ClosedCVsList from "./Vessel_Owner/VesselOwner/ClosedCvs.jsx";
import VacancyBasedCVsList from "./Crewing_Agent/DrawerTabs/SelectedCvsList.jsx";
import BuisnessDevelopment from "./Vessel_Owner/BuisnessDevelopment/BuisnessDevelopment.jsx";
import VacancyBasedCrewCVs from "./crew/matchedVacanciesForCv/matchedvacancyfocvs.jsx";
import AssignedCrewCvVesselowner from "./Vessel_Owner/AssignedCrewCvVesselowner/AssignedCrewCvVesselowner.jsx";


const theme = createTheme();
const stripePromise = loadStripe('pk_test_51RVUFzFsQR3NfwbFhZ0eVGOy8kP7cxu8iRwfc3fX0js8eZNirQvrC0ysz2KS2sTHf3HAXv9LhUAay4ByRiJSwVaY00Q45Qqkud');

function App() {
  const route = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/signup",
      element: <Signup />,
    },
    {
      path: "/AdminDashboard",
      element: <AdminDashboard />,
    },
    {
      path: "/VesselOwnerRefundRequests",
      element: <VesselOwnerRefundRequests />
    },
    {
      path: "/AllAdminContract",
      element: <AllAdminContract />
    },
    {
      path: "/AllAdminCrewing",
      element: <AllAdminCrewing />
    },
    {
      path: "/AdminContractDetails",
      element: <AdminContractDetails />
    },
    {
      path: "/adminSignup",
      element: <AdminSignup />
    },
    {
      path: "/otp",
      element: <Otp />
    },
    {
      path: "/forgotPassword",
      element: <ForgotPassword />
    },
    {
      path: "/crewprofile",
      element: <CrewProfile />,
    }, {
      path: "/CrewInfo/:id",
      element: <CrewInfo />
    },
    {
      path: "/AssignedCrew",
      element: <AssignedCrew />
    },
    {
      path: "/Crewcvs",
      element: <Crewcvs />
    },
    {
      path: "/MatchedVacanciesForCVs",
      element: <VacancyBasedCrewCVs />
    },
    {
      path: "/Listofvacancy",
      element: <Listofvacancy />
    },
    {
      path: "/CrewProfileTable",
      element: <CrewProfileTable />
    },
    {
      path: "/AddRank/:id",
      element: <AddRank />
    },
    {
      path: "/AddRank",
      element: <CreateRank />
    },
    {
      path: "/RankTable",
      element: <RankTable />
    },
    {

      path: "/vessel_owner_table",
      element: <VesselOwnerTable />,
    },
    {
      path: "/BuisnessDevelopment",
      element: <BuisnessDevelopment />
    },
    {
      path: "VesselOwnerContract",
      element: <VesselOwnerContract />

    },
    {
      path: "/VesselOwnerContract/:id",
      element: <VesselOwnerContracts />
    },
    {
      path: "/vesselownerform",
      element: <VesselOwnerForm />,

    },
    {
      path: "/AssignedCrewCvVesselowner",
      element: <AssignedCrewCvVesselowner />,
    },
    {
      path: "/manningAggrement",
      element: <ManningAggrement />,
    },
    {
      path: "/vessel",
      element: <VesselForm />,
    },
    {
      path: "/vessel_Table",
      element: <VesselTable />,
    },
    {
      path: "/vesselsforagent/:crewingAgentId",
      element: <Vesselsforagent />,
    },
    {
      path: "/vessel_Table/vessel/:id",
      element: <VesselForm />
    },
    {
      path: "/VesselTableByVesselOwnerId/:id",
      element: <VesselTableByVesselOwnerId />
    },

    {
      path: "subscriptionvesselowner",
      element: (
        <Elements stripe={stripePromise}>
          <StripeSubscriptionForm />
        </Elements>
      )
    },
    {
      path: "/ManningAggrementDisplay",
      element: <ManningAggrementDisplay />,
    },
    //vessel Manger routes
    {
      path: "/VesselMangerForm",
      element: <VesselMangerForm />,
    },
    {
      path: "/VesselManagerTable",
      element: <VesselManagerTable />
    },
    {
      path: "/set-permissions",
      element: <SetPermissionPage />,
    },
    //Crewing_Agent routes
    {
      path: "/Crewing_Agent",
      element: <CrewingAgentForm />,
    },
    // {
    //   path: "/Crewing_Agent",
    //   element: <CrewingAgentDrawer />,
    // },
    {
      path: `/CrewingAgentTable/:id`,
      element: <CrewingAgentTable />,
    },
    {
      path: "/CrewingAgentTable",
      element: <CrewingAgentTable />,
    },
    {
      path: `/SignInSignOff/:id`,
      element: <SignInSignOffCrewing />
    },
    {
      path: "/CrewingAgentFormIList/:crewingAgentId",
      element: <CrewingAgentFormIList />
    },
    // Vessel route with dynamic ID
    {
      path: "/vessel/:id",
      element: <VesselForm />,
    },
    {
      path: "/vessel_Table/:id",
      element: <VesselTable />
    },
    {
      path: "/vessel_Table/vesselTable/:id",
      element: <VesselTable />
    },
    //AssignedVesselTable
    {
      path: "/AssignedVesselTable",
      element: <AssignedVesselTable />
    },
    {
      path: "/AgentDetails",
      element: <AgentDetails />
    },
    //contract page route
    {
      path: "/ContractForm",
      element: <ContractForm />
    },
    {
      path: "/ContractForVesselOwner",
      element: <ContractForVesselOwner />
    },
    {
      path: "/ContractTable",
      element: <ContractTable />
    },
    {
      path: "/EditContractTable",
      element: <EditContractTable />
    },
    // {
    //   path: "/ContractTable/:id",
    //   element: <ContractTable />
    // },
    {
      path: "/SignInSignOff",
      element: <SignInSignOff />
    },
    {
      path: "/ContractUpdate/:id",
      element: <ContractUpdate />
    },
    {
      path: "/contractDocument",
      element: <CrewingAgentContractDocument />
    },
    //compnay route
    {
      path: "/CompanyVessel",
      element: <CompanyVessel />
    },
    {
      path: "/ExecutiveForm/:id",
      element: <ExecutiveForm />
    },
    {
      path: "/ExecutiveVesselInfo/:id",
      element: <ExecutiveVesselInfo />
    },
    {
      path: "/ExecutiveVesselInfo",
      element: <ExecutiveVesselInfo />
    },
    {
      path: "/ExecutiveTable/:id",
      element: <ExecutiveTable />
    },
    {
      path: "/expiring-vessels",
      element: <ExpiringShipDetails />
    },
    {
      path: "/user-list",
      element: <UserList />
    },
    {
      path: "/crew-agent/:agentId",
      element: <CrewAgentDetails />
    },
    {
      path: "/CharteredVessel",
      element: <CharteredVessel />
    },
    { path: "logout", element: <LogOut /> },

    //vessel owner routes
    {
      path: "/VesselOwnerLayouts/:id",
      element: <VesselOwnerLayouts />,
      children: [
        { index: true, element: <DashBoard /> },
        { path: "Listofcvs", element: <Listofcvs /> },
        { path: "dashboard", element: <DashBoard /> },
        { path: "profile", element: <VesselOwnerProfile /> },
        { path: "vacancy/AddVacancy", element: <AddVacancy /> },
        { path: "vacancy/vacancycvs", element: <VacancyCvMatcher /> },
        { path: "vacancy/vacancylist", element: <VacancyList /> },
        { path: "vacancy/closedcvs", element: <ClosedCVsList /> },
        { path: "vessels/addVessel", element: <AddVessel /> },
        { path: "vessels/list", element: <VesselList /> },
        { path: "vessels/assigned", element: <AssignedVessel /> },
        { path: "crew/add", element: <AddCrew /> },
        { path: "crew/list", element: <CrewList /> },
        { path: "contracts/bsm", element: <BsmContracts /> },
        { path: "contracts/owners", element: <VesselContarcts /> },
        { path: "executive/add", element: <AddExecutive /> },
        { path: "executive/list", element: <ExecutiveList /> },
        { path: "subscriptionvesselowner", element: <SubscriptionWrapper /> },
        { path: "subscription/history", element: <VesselOwnerSubscriptionHistory /> },
        { path: "stripsubscriptionvesselowner", element: <StripSubscription /> },
        { path: "wallet", element: <Wallet /> },
        { path: "ModifySubscription", element: <ModifySubscription /> },
        { path: "RenewSubscription", element: <RenewSubscription /> },
        { path: "topup-success", element: <TopupSuccessPage /> },
      ]
    },

    {
      path: "/ContractTable/:id", // dynamic id for agent
      element: <CrewingAgentLayout />,
      children: [
        { index: true, element: <CrewingAgentDashboard /> }, // default page
        { path: "dashboard", element: <CrewingAgentDashboard /> },
        { path: "profile", element: <CrewingAgentProfile /> },
        { path: "CrewingContracts", element: <CrewingContracts /> },
        { path: "CrewingEditContractTable", element: <CrewingEditContractTable /> },
        { path: "bankdetails", element: <CrewingAgentBankDetails /> },
        { path: "upload-cv", element: <UploadCV /> },
        { path: "get-uploaded-cvs", element: <UploadedCVsList /> },

        { path: "profile", element: <CrewingAgentProfile /> },

        { path: "bankdetails", element: <CrewingAgentBankDetails /> },
        // { path: "crews", element: <Crews /> },
        // { path: "contracts", element: <Contracts /> },

        { path: "CrewingContracts", element: <CrewingContracts /> },
        { path: "CrewingEditContractTable", element: <CrewingEditContractTable /> },
        //         { path: "bankdetails", element: <CrewingAgentBankDetails /> },
        { path: "AssignedVessels", element: <AssignedVessels /> },
        { path: "AssignedCrewToAgent", element: <AssignedCrewToAgent /> },
        { path: "Signinsignoffcrewingagent", element: <Signinsignoffcrewingagent /> },
        { path: "Seaservicecrewing", element: <Seaservicecrewing /> },
        { path: "get-matched-cvs", element: <VacancyBasedCVsList /> },

        {
          path: "executive",
          children: [
            { path: "add", element: <CrewingAgentExecutive /> },
            { path: "list", element: <ListOfCrewingAgentExecutive /> },
          ],
        }

      ],
    }

  ]);


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="colored"
        style={{ zIndex: 999999 }}
      />

      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <NotificationProvider>
            <RouterProvider router={route} />
          </NotificationProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </>
  );
}




export default App;
